import { useState } from 'react'
import { FullScreenModal } from '../../utility/FullScreenModal'

export const EquipItem = () => {
   const [showModal, setShowModal] = useState(false)
   const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
   const handleOpenModal = (contentType, category, index, maxIndex) => {
       setModalContent({ contentType, category, index, maxIndex })
       setShowModal(true)
   }
  const handleCloseModal = () => {
      setModalContent({ contentType: '', category: '', index: 0 })
      setShowModal(false)
  }
    return (
        <>
            <div className='max-w-[1200px] mx-auto'>
                <div className='flex justify-center mt-12'>
                    <img
                        className=''
                        alt='gameflow button'
                        src={`${process.env.PUBLIC_URL}/images/system/system-header-equip.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        In this game, all items can be <span className='text-pborange'>equipped</span>. Not only swords
                        or staffs, but the{' '}
                        <span className='text-pborange'>
                            rocks and flowers on the maps, and even the enemies themselves can be equipped
                        </span>
                        !
                    </p>{' '}
                    <div className='mt-8 w-full md:w-4/5 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal('image', 'equipment', 1)
                            }}
                            className='ss-thumb max-w-full'
                            alt='gameflow button'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-equipment-1-s.webp`}
                        />{' '}
                        <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                            Things on the map like characters and items can be equipped by “lifting” them.
                        </p>
                    </div>{' '}
                    <div className='mt-8 w-full md:w-4/5 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal('image', 'equipment', 2)
                            }}
                            className='ss-thumb max-w-full'
                            alt='gameflow button'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-equipment-2-s.webp`}
                        />{' '}
                        <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                            You can also steal the enemies' weapons and equip them! Be sure to check the probability of
                            a successful steal!
                        </p>
                    </div>{' '}
                    <p className='mt-8'>
                        Equip items have both <span className='text-pborange'>Skills</span> and{' '}
                        <span className='text-pborange'>Abilities</span>. Characters who equip these items can use their
                        Skills and will receive the effects of their Abilities.
                    </p>{' '}
                    <div className='mt-8'>
                        <div className='flex flex-col md:flex-row gap-4 mt-8'>
                            <div className='w-full md:w-1/2'>
                                <img
                                    onClick={() => {
                                        handleOpenModal('image', 'equipment', 3)
                                    }}
                                    className='ss-thumb'
                                    alt='screen shot of game system'
                                    src={`${process.env.PUBLIC_URL}/images/ss/ss-equipment-3-s.webp`}
                                />
                            </div>
                            <div className='w-full md:w-1/2'>
                                <img
                                    onClick={() => {
                                        handleOpenModal('image', 'equipment', 4)
                                    }}
                                    className='ss-thumb'
                                    alt='screen shot of game system'
                                    src={`${process.env.PUBLIC_URL}/images/ss/ss-equipment-4-s.webp`}
                                />{' '}
                            </div>{' '}
                        </div>{' '}
                        <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                            Skills can be thought of as “techniques,” while Abilities are “passive” skills.
                        </p>
                    </div>{' '}
                    <p className='mt-8'>
                        In Phantom Brave: The Lost Hero, you can also equip various objects that are on the field. When
                        you don't have an item equipped, try equipping things like grass, trees, or rocks! Trees, rocks,
                        etc. also have Skills and Abilities and by equipping them, you will gain access to various
                        Skills and status-boosting effects.
                    </p>{' '}
                    <div className='mt-8'>
                        <div className='flex flex-col md:flex-row gap-4 mt-8'>
                            <div className='w-full md:w-1/2'>
                                <img
                                    onClick={() => {
                                        handleOpenModal('image', 'equipment', 5)
                                    }}
                                    className='ss-thumb'
                                    alt='screen shot of game system'
                                    src={`${process.env.PUBLIC_URL}/images/ss/ss-equipment-5-s.webp`}
                                />
                            </div>
                            <div className='w-full md:w-1/2'>
                                <img
                                    onClick={() => {
                                        handleOpenModal('image', 'equipment', 6)
                                    }}
                                    className='ss-thumb'
                                    alt='screen shot of game system'
                                    src={`${process.env.PUBLIC_URL}/images/ss/ss-equipment-6-s.webp`}
                                />{' '}
                            </div>{' '}
                        </div>{' '}
                        <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                            By equipping this palm tree that was on the map, you are able to use “Multi-Thrust” and
                            “Mini Heal!”
                        </p>
                    </div>{' '}
                    <p className='mt-8'>
                        Furthermore, if you <span className='text-pborange'>meet certain conditions</span>, you can
                        permanently learn these Skills and Abilities. Learning powerful Skills and Abilities will surely
                        aid you in the battles ahead!
                    </p>{' '}
                    <div className='md:w-4/5 w-full mt-8 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal('image', 'equipment', 7)
                            }}
                            className='ss-thumb max-w-full'
                            alt='gameflow button'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-equipment-7-s.webp`}
                        />{' '}
                    </div>{' '}
                    <p className='mt-8'>
                        When a character takes damage, an equipped item or another character will become their shield,
                        <span className='text-pborange'> taking on</span> a portion of the damage themselves! However,
                        if the equipped item's HP is reduced to 0, then{' '}
                        <span className='text-pborange'>the item will be lost</span>, and if the assisting character's
                        HP falls to 0,{' '}
                        <span className='text-pborange'>they will be Downed and become unable to fight</span>.
                        Furthermore, if this item or character sustains another attack, they become Fallen and are{' '}
                        <span className='text-pborange'>removed from the map</span>.
                    </p>{' '}
                </div>{' '}
                <FullScreenModal
                    showModal={showModal}
                    modalContent={modalContent}
                    setModalImage
                    handleCloseModal={handleCloseModal}
                    setModalContent={setModalContent}
                    maxIndex={7}
                />
            </div>
        </>
    )
}
